import React from 'react';
import PropTypes from 'prop-types';
import makeRequest from 'utils/makeRequest';
import { UserPreferenceContext } from 'routes/home/layouts/India/context';
import Link from 'components/Link';
import InViewObserver from 'components/InViewObserver';
import InterSectionBorder from 'components_v2/common/InterSectionBorder';
import LoaderSpinner from 'components_v2/common/LoaderSpinner';
import CardList from 'components_v2/common/CardListV2';
import SixColumnLayout from 'components_v2/desktop/SixColumnLayoutV2';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import Listingheader from '../../common/ListingheaderV2';
import s from './Entertainment.scss';
import CityModal from '../CityModal/CityModalLoader';
import getDataUrlFromLang from '../../../utils/navMappings';
import { cityNameMap } from '../../../../../utils/common';

const featuredCardIndex = 0;

class Entertainment extends React.Component {
  constructor() {
    super();
    this.state = {
      shouldshowModal: false,
      cityForSection: null,
      navItems: null,
    };
  }

  // componentDidMount() {
  //   this.loadNavigationData();
  // }

  componentDidUpdate(prevProps, prevState) {
    const { geoCityData: { city: prevCity = '' } } = prevProps;
    const { geoCityData: { city } } = this.props;

    // const { cityForSection } = this.state;
    // console.log(
    //   '*** Entertainment componentDidUpdate ',
    //   prevCity,
    //   city,
    //   cityForSection,
    //   this.state.navItems,
    // );

    if (
      ((prevCity || city) &&
        prevCity !== city &&
        this.state.navItems &&
        this.state.navItems.length > 0) ||
      (!prevState.navItems &&
        city &&
        this.state.navItems &&
        this.state.navItems.length > 0)
    ) {
      this.loadDataForCity(city);
    }
  }

  loadDataForCity = city => {
    if (typeof city !== 'string') {
      return;
    }
    const cityName = city.toLocaleLowerCase();
    const { navItems } = this.state;
    if (!Array.isArray(navItems)) {
      return;
    }
    const filteredCityByAlphabet = navItems.filter(node => {
      const alphabet =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      return alphabet === cityName[0];
    });
    if (
      !(
        Array.isArray(filteredCityByAlphabet) &&
        filteredCityByAlphabet[0] &&
        Array.isArray(filteredCityByAlphabet[0].items)
      )
    ) {
      return;
    }
    const filteredCity = filteredCityByAlphabet[0].items.filter(node => {
      const nodeName =
        typeof node.name === 'string' ? node.name.toLowerCase() : '';
      return nodeName === cityName;
    });

    const dataUrl = getDataUrlFromLang(
      filteredCity[0] && filteredCity[0].lang,
      this.langMapping,
    );
    this.loadSectionData(dataUrl, true);
  };

  loadNavigationData() {
    const { sectionData = {} } = this.props;
    if (sectionData.subSections && sectionData.subSections.dataUrl) {
      this.fetchNavigation(sectionData.subSections.dataUrl);
    }
  }

  fetchNavigation(dataUrl) {
    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (!(data && data.data)) {
          return;
        }
        const { items, langMapping } = data.data;
        this.setState({
          navItems: items,
        });
        if (langMapping) {
          this.langMapping = langMapping;
        }
      });
  }

  onTabsChange = params => {
    const { clickedItem: { name }, confirmMakingDefCity } = params;
    if (confirmMakingDefCity && name && this.context) {
      this.setState({
        cityForSection: null,
      });
      this.context.setLanguageVal(name, true);
    } else {
      this.setState({
        cityForSection: name,
      });
      if (params && params.clickedItem && params.clickedItem.dataUrl) {
        this.loadSectionData(params.clickedItem.dataUrl, true);
      }
    }
  };

  loadSectionData = (dataUrl, ajaxCall) => {
    if (!dataUrl) {
      return;
    }

    this.setState({ loading: true });

    makeRequest
      .get(dataUrl, { isMobile: false }, 'skipfeedengine')
      .then(data => {
        if (
          data &&
          data.data &&
          data.data.items &&
          data.data.items.length > 0
        ) {
          //console.log('data : ', data.data);
          this.setState({
            items: data.data.items,
            ajaxCall: !!ajaxCall,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
        }
      });
  };

  toggleModal = () => {
    this.setState({
      shouldshowModal: !this.state.shouldshowModal,
    });

    if (!this.state.shouldshowModal) {
      const { sectionData = {} } = this.props;
      sendGaThroughProps({
        data: {
          // gaCategory: ,
          gaAction: `${sectionData.name}Section_CityChange`,
          gaLabel: 'CityChange_Click',
        },
      });
    }
  };

  getGAVal = (gaData, data) => {
    if (typeof gaData !== 'string' || !gaData) {
      return '';
    }

    let type = 'Article';
    if (data.type === 'video' || data.tn === 'video') {
      type = 'Video';
    } else if (data.type === 'photostory' || data.tn === 'photostory') {
      type = 'Photo';
    }

    return gaData.replace('$type', type);
  };

  render() {
    const { shouldshowModal, cityForSection } = this.state;
    const { sectionData = {}, geoCityData, geoCityData: { city } } = this.props;
    const { ga4Type = '', ga4Category = '' } = sectionData;
    //const itemsList = data || items || [];
    let itemsList;
    if (this.state.ajaxCall) {
      itemsList = this.state.items;
    } else {
      itemsList = sectionData.data || sectionData.items || this.state.items;
    }

    const scrollGAAttr = {
      ...(sectionData.onScrollGA &&
        sectionData.id && { 'data-scrollga': sectionData.id }),
    };

    //const { data } = sectionData;
    let featuredCard;
    let otherCards;
    const columnList = [];
    const rowList = [];
    // const activeSubsection = sectionData.subSections.find(
    //   subsec => subsec.active,
    // );

    if (!Array.isArray(itemsList)) {
      return null;
    }

    itemsList.map((item = {}) => {
      switch (item.tn) {
        case 'lead_plus_4_list':
          {
            const itemsArr = item.data || item.items;
            const featuredItems = [];
            let otherItems;
            if (itemsArr instanceof Array) {
              otherItems = itemsArr.filter((dataItem, dataIndex) => {
                if (dataIndex === featuredCardIndex) {
                  // eslint-disable-next-line no-param-reassign
                  dataItem.tn = 'featured';
                  featuredItems.push(dataItem);
                  return null;
                }
                return dataItem;
              });
              featuredCard = (
                <CardList
                  data={featuredItems}
                  //showDescription
                  // newga={`${
                  //   sectionData.name
                  // }Section_Actions#$typeClick/lead/Grid1/`}
                  newga={`click-${sectionData.name}-lead-`}
                  imgWidth="400"
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                />
              );
              otherCards = (
                <CardList
                  data={otherItems}
                  nonFeaturedListWrapperClass="grid_wrapper"
                  nonFeaturedItemWrapperClass={`${'col_l_6'}`}
                  newga={`click-${sectionData.name}-`}
                  imgWidth="200"
                  showDuration={false}
                  showPhotosCount={false}
                  itemClass={`${s.entCardSpacing}`}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                />
              );
            }
          }
          return null;

        case 'column_2_list': {
          if ((item.data || item.items) instanceof Array) {
            (item.data || item.items).forEach((i, index) => {
              columnList.push(
                <Link
                  className={`linktype1 ${
                    i.tn === 'liveblog' ? s.lbBlinker : ''
                  }`}
                  to={i.wu}
                  data-newga={this.getGAVal(
                    `click-${sectionData.name}-${index}#${i.wu || ''}`,
                    i,
                  )}
                  key={index}
                  target={i.target === '_blank' ? i.target : ''}
                  ga4Data={
                    ga4Type && [
                      {
                        event: 'user_click',
                        type: `${ga4Type}`,
                        category: `${ga4Category || 'story_click'}`,
                        story_no: `${index + 1}`,
                        msid: i?.id,
                      },
                    ]
                  }
                >
                  {i.tn === 'liveblog' ? (
                    <div className={`${s.liveBtn} ${s.red}`} />
                  ) : (
                    ''
                  )}
                  <span>
                    {/* {typeof i.titlePrefix !== 'undefined' && (
                      <small className="toiPlusTag">{i.titlePrefix}:</small>
                    )} */}
                    {i.hl}
                  </span>
                  {i.type === 'photostory' || i.tn === 'photostory' ? (
                    <i className="icon photos" />
                  ) : null}
                  {i.type === 'video' || i.tn === 'video' ? (
                    <i className="icon videos" />
                  ) : null}
                </Link>,
              );
            });
          }
          return null;
        }

        case 'row_next_list': {
          if ((item.data || item.items) instanceof Array) {
            rowList.push(
              <SixColumnLayout
                sectionData={item}
                key={item.id}
                gridNotRequired
                oneByOneCard={s.onebyonCard}
                wrapperClass={s.EtimesWidget}
              />,
            );
          }

          return null;
        }

        default: {
          return null;
        }
      }
    });
    return (
      <InViewObserver
        inViewCallback={() => {
          this.loadNavigationData();
        }}
        viewMargin="300px 0px 300px 0px"
      >
        <div className={s.section_wrapper} {...scrollGAAttr}>
          {sectionData.border &&
            sectionData.border === 'top' && (
              <InterSectionBorder border={sectionData.border} />
            )}
          {this.state.loading && <LoaderSpinner />}

          <Listingheader
            headingname={sectionData.name}
            headingLink={sectionData.link || sectionData.path}
            newga={`${sectionData.name}Section_Actions#HeadingClick`}
            target={sectionData.target === '_blank' ? sectionData.target : ''}
            ga4Type={ga4Type}
            ga4Category={ga4Category}
          >
            <>
              {shouldshowModal &&
                sectionData.subSections &&
                sectionData.subSections.dataUrl && (
                  <CityModal
                    dataUrl={sectionData.subSections.dataUrl}
                    onChangeCallback={this.onTabsChange}
                    gaData={{
                      gaAction: `${sectionData.name}Section_CityChange`,
                      partialGaLabel: 'CityChange_',
                    }}
                    geoCityData={geoCityData}
                    toggleModal={this.toggleModal}
                  />
                )}
              {!sectionData?.shownocitydropdown &&
                sectionData?.shownocitydropdown !== '1' && (
                  <div className={s.cityDropdown}>
                    <div className={s.currentcity}>
                      {cityNameMap[cityForSection] ||
                        cityForSection ||
                        cityNameMap[city] ||
                        city}
                    </div>
                    <div className={s.changecity} onClick={this.toggleModal}>
                      Change City
                    </div>
                  </div>
                )}
            </>
          </Listingheader>
          <div className={`${'grid_wrapper'}`}>
            <div className={`${'col_l_8 col_m_12 padR32'} ${s.rhs_border}`}>
              <div className="grid_wrapper">
                <div className={`${'col_l_6'}`}>
                  <div>{featuredCard}</div>
                  {otherCards}
                </div>
                <div className={`${'col_l_6'}`}>{columnList}</div>
              </div>
            </div>
            <div className={`${'col_l_4 col_m_12'} ${s.leftColSpacing}`}>
              {React.isValidElement(<this.props.insertComp />) ? (
                <this.props.insertComp
                  data={itemsList && itemsList[2] && itemsList[2].inserts}
                  isPrime={this.props.isPrime}
                  ga4Type={ga4Type}
                  ga4Category={ga4Category}
                />
              ) : (
                ''
              )}
            </div>

            {rowList &&
              rowList.length > 0 &&
              rowList.map((dataItem, index) => (
                <div key={index} className={`${'col_l_12'}`}>
                  {dataItem}
                </div>
              ))}
          </div>

          {itemsList &&
            Array.isArray(itemsList) &&
            itemsList.length > 2 &&
            itemsList[2] &&
            itemsList[2].reviews_insert && (
              <div className={`${'grid_wrapper'}`}>
                <div className={`${'col_l_8 col_m_12 padR32'} ${s.rhs_border}`}>
                  <div className={`${s.movieReview}`}>
                    {React.isValidElement(<this.props.insertComp />) ? (
                      <this.props.insertComp
                        data={
                          itemsList &&
                          itemsList[2] &&
                          itemsList[2].reviews_insert
                        }
                        isPrime={this.props.isPrime}
                        ga4Type={
                          itemsList && itemsList[2]?.reviews_insert[0]?.ga4Type
                            ? itemsList[2]?.reviews_insert[0]?.ga4Type
                            : ga4Type
                        }
                        ga4Category={
                          itemsList &&
                          itemsList[2]?.reviews_insert[0]?.ga4Category
                            ? itemsList[2]?.reviews_insert[0]?.ga4Category
                            : ga4Category
                        }
                      />
                    ) : (
                      ''
                    )}
                  </div>
                </div>
                <div
                  className={`${'col_l_4 col_m_12'} ${s.leftColSpacing} ${
                    s.movieReview
                  }`}
                >
                  {React.isValidElement(<this.props.insertComp />) ? (
                    <this.props.insertComp
                      data={itemsList && itemsList[2] && itemsList[2].ad_insert}
                      isPrime={this.props.isPrime}
                      ga4Type={ga4Type}
                      ga4Category={ga4Category}
                    />
                  ) : (
                    ''
                  )}
                </div>
              </div>
            )}
          {itemsList &&
            Array.isArray(itemsList) &&
            itemsList.length > 2 &&
            itemsList[2] &&
            itemsList[2].reviews && (
              <div className={s.movieReview}>
                {React.isValidElement(<this.props.insertComp />) ? (
                  <this.props.insertComp
                    data={itemsList && itemsList[2] && itemsList[2].reviews}
                    isPrime={this.props.isPrime}
                    ga4Type={
                      itemsList &&
                      itemsList[2] &&
                      Array.isArray(itemsList[2].reviews) &&
                      itemsList[2].reviews.length > 0 &&
                      itemsList[2]?.reviews[0]?.ga4Type
                        ? itemsList[2]?.reviews[0]?.ga4Type
                        : ga4Type
                    }
                    ga4Category={ga4Category}
                  />
                ) : (
                  ''
                )}
              </div>
            )}
        </div>
      </InViewObserver>
    );
  }
}

Entertainment.propTypes = {
  children: PropTypes.node.isRequired,
  sectionData: PropTypes.shape({}).isRequired,
  geoCityData: PropTypes.shape({}),
  insertComp: PropTypes.element,
  isPrime: PropTypes.bool,
  ga4Category: PropTypes.string,
  ga4Type: PropTypes.string,
};

Entertainment.defaultProps = {
  geoCityData: {},
  insertComp: undefined,
  isPrime: false,
  ga4Type: '',
  ga4Category: '',
};

Entertainment.contextType = UserPreferenceContext;

export default Entertainment;
